import { createFileRoute } from '@tanstack/react-router';
import { WageLedgerLayoutRegistryPage } from './-components/WageLedgerLayoutRegistryPage';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/settings/wage-ledgers/')({
  component: WageLedgerLayoutRegistryPage
});